export default {
  order: null,
  loading: false,
  readyStatusModalIsOpen: false,
}
